// @flow
// Mixin to help with swipe left / right and locking vertical scroll
// Component should define handleSwipe callback methods
// TODO: convert to vue 3 composition API
export default {
  // this data will be merged with component using mixing
  data() {
    return {
      swipe: {
        verticalScrollLock: false,
        // note that the following are added but not reactive
        // @see https://vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats
        // touchStartX
        // touchStartY
      },
    }
  },
  watch: {
    // whenever question changes, this function will run
    'swipe.verticalScrollLock': function (newVal: boolean, oldVal: boolean) {
      if (newVal !== oldVal) {
        if (newVal) {
          // eslint-disable-next-line
          document.querySelector('body').style.overflow = 'hidden'
        } else {
          // eslint-disable-next-line
          document.querySelector('body').style.overflow = 'auto'
        }
      }
    },
  },
  methods: {
    swipeStart(e: TouchEvent) {
      if (e && e.changedTouches) {
        // properties are not reactive as they are added AFTER vue mount
        // @see https://vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats
        this.swipe.touchStartX = e.changedTouches[0].screenX
        this.swipe.touchStartY = e.changedTouches[0].screenY
      }
    },
    swipeMove(e: TouchEvent) {
      if (
        this.swipe.touchStartX &&
        this.swipe.touchStartY &&
        e &&
        e.changedTouches &&
        !this.swipe.verticalScrollLock
      ) {
        const touchEndX = e.changedTouches[0].screenX
        const touchEndY = e.changedTouches[0].screenY
        const diffX = Math.abs(touchEndX - this.swipe.touchStartX)
        const diffY = Math.abs(touchEndY - this.swipe.touchStartY)
        // swipe horizontal only, no action if mostly vertical
        if (diffX > diffY) {
          // required for iOS to stop scrolling
          e.preventDefault()

          // swipe right
          if (this.swipe.touchStartX < touchEndX) {
            this.swipe.verticalScrollLock = true
          }
          // swipe left
          if (this.swipe.touchStartX > touchEndX) {
            this.swipe.verticalScrollLock = true
          }
        }
      }
    },
    swipeEnd(e: TouchEvent) {
      if (this.swipe.touchStartX && this.swipe.touchStartY && e && e.changedTouches) {
        const touchEndX = e.changedTouches[0].screenX
        const touchEndY = e.changedTouches[0].screenY
        const diffX = Math.abs(touchEndX - this.swipe.touchStartX)
        const diffY = Math.abs(touchEndY - this.swipe.touchStartY)
        // swipe horizontal only, no action if mostly vertical
        if (diffX > diffY) {
          // swipe right, defined by component
          if (this.swipe.touchStartX < touchEndX && this.handleSwipe) {
            this.handleSwipe({
              direction: 'right',
            })
          }
          // swipe left, defined by component
          if (this.swipe.touchStartX > touchEndX && this.handleSwipe) {
            this.handleSwipe({
              direction: 'left',
            })
          }
        }
      }
      // clear start
      this.swipe.touchStartX = null
      this.swipe.touchStartY = null
      // remove scroll lock
      this.swipe.verticalScrollLock = false
    },
  },
}
